export default __webpack_public_path__ + "static/panorama-d96dfb46e75acd2f7de77c39f87eb4b7.jpg";